import _ from 'lodash';
import { prepareBaseAutoSaveData, resolveAutoSaveSanitizeOptions } from './shared';
import { createJsonConfiguredAutoSaveAdapter } from './jsonAutoSave';

export const createIndividualLiteAutoSaveAdapter = (applicationForm, fieldDefinitions = {}, autoSaveConfig = null) => createJsonConfiguredAutoSaveAdapter({
    autoSaveConfig: _.cloneDeep(autoSaveConfig || {}),
    fieldDefinitions: _.cloneDeep(fieldDefinitions || {}),
    runtimeRecords: {
        applicationForm,
    },
    prepareData(data) {
        return prepareBaseAutoSaveData(data, resolveAutoSaveSanitizeOptions(autoSaveConfig));
    },
});
